// extracted by mini-css-extract-plugin
export default {"summary-container":"EntityReportSummary_summary-container__gI54Z","summary-ctas":"EntityReportSummary_summary-ctas__AF10f"};